import React, { useEffect, useState } from 'react';
import { useApi, identityApiRef } from '@backstage/core-plugin-api';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';

export const OktaEmailField = ({
  onChange,
  rawErrors,
  formData,
}: FieldExtensionComponentProps<string>) => {
  const identityApi = useApi(identityApiRef);
  const [baseEmail, setBaseEmail] = useState('');
  const [alias, setAlias] = useState('');

  useEffect(() => {
    identityApi.getProfileInfo().then(profile => {
      if (profile?.email) {
        setBaseEmail(profile.email);
        if (!formData) onChange(profile.email);
      }
    }).catch(() => {});
  }, []);

  const handleAliasChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setAlias(value);
    const local = baseEmail.split('@')[0];
    const domain = baseEmail.split('@')[1];
    const full = value ? `${local}+${value}@${domain}` : baseEmail;
    onChange(full);
  };

  if (!baseEmail) return (
    <div style={{ color: '#888', fontSize: 13, padding: '8px 0' }}>
      Loading your profile...
    </div>
  );

  return (
    <div>
      <div style={{ fontSize: 13, color: '#b0b0c0', marginBottom: 6 }}>
        Logged in as <strong style={{ color: '#e0e0f0' }}>{baseEmail}</strong>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 14 }}>
        <span style={{ color: '#888' }}>{baseEmail.split('@')[0]}</span>
        <span style={{ color: '#90caf9' }}>+</span>
        <input
          type="text"
          placeholder="alias (optional, e.g. demo1)"
          value={alias}
          onChange={handleAliasChange}
          style={{
            background: '#1a1a2e', border: '1px solid #444', borderRadius: 4,
            color: '#e0e0f0', padding: '6px 10px', fontSize: 13, width: 200,
          }}
        />
        <span style={{ color: '#888' }}>@{baseEmail.split('@')[1]}</span>
      </div>
      <div style={{ fontSize: 12, color: '#666', marginTop: 6 }}>
        Leave alias empty to use your base email. Add an alias for additional sandboxes.
      </div>
      {rawErrors?.length > 0 && (
        <div style={{ color: '#f44336', fontSize: 12, marginTop: 4 }}>{rawErrors[0]}</div>
      )}
    </div>
  );
};
